import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { propTypes as reduxFormPropTypes, reduxForm } from 'redux-form';
import EditSelectionForm from '../../common/components/EditSelectionForm';

// eslint-disable-next-line no-unused-vars
function isNothingSelected(categories) {
  return !Object.entries(categories)
    .find((categoriesProperty) => {
      const categoriesPropertyValue = categoriesProperty[1];

      return categoriesPropertyValue.selected.length !== 0;
    });
}

const validate = (values, props) => {
  const errors = {};
  const field = 'name';

  if (props.categories.length === 0) {
    errors[field] = (
      <div id="no-mailsubclasses-selected">
        <FormattedMessage id="app.no.mailsubclasses.selected" />
      </div>
    );
  }

  return errors;
};

// eslint-disable-next-line react/prefer-stateless-function
class EditProductSelectionFormContainer extends Component {
  render() {
    const {
      onCloseModal,
      handleSubmit,
      name,
      errorMessage,
    } = this.props;

    return (<EditSelectionForm
      onCloseModal={onCloseModal}
      handleSubmit={handleSubmit}
      errorMessage={errorMessage}
      name={name}
    />);
  }
}

EditProductSelectionFormContainer.propTypes = {
  ...reduxFormPropTypes,
  onCloseModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default reduxForm({
  form: 'saveSelection',
  validate,
})(EditProductSelectionFormContainer);
